/*  ========================================================================
    # Components - Post Card
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from '../hooks/useTranslation';
import bem from '../helpers/bem';
import tailwindConfig from '../../../tailwind.config';
import LazyImage from './LazyImage';
import LazySource from './LazySource';

export const PostCardSkeleton = () => {
  return (
    <div className={bem('c-post-card', '', { skeleton: true })} style={{ order: 9999 }}>
      <div className={bem('c-post-card', 'image')} />
      <div className={bem('c-post-card', 'content')}>
        <p className={bem('c-post-card', 'info')} />
        <p className={bem('c-post-card', 'title')} />
        <p className={bem('c-post-card', 'excerpt')} />
        <div className={bem('c-post-card', 'show-more')} />
      </div>
    </div>
  );
};

export const PostCard = ({ style, permalink, image, info, title, excerpt }) => {
  const __ = useTranslation();

  return (
    <a className={bem('c-post-card')} href={permalink} title={title} style={style}>
      <LazyImage
        figureClass={bem('c-post-card', 'image')}
        defaultUrl={image.sizes.medium}
        placeholderUrl={image.sizes.placeholder}
        alt={image.alt}
      >
        <LazySource srcSet={image.sizes.medium} mediaMin={tailwindConfig.theme.screens.sm} />
      </LazyImage>
      <div className={bem('c-post-card', 'content')}>
        <span className={bem('c-post-card', 'info')} dangerouslySetInnerHTML={{ __html: info }} />
        <h3
          className={bem('c-post-card', 'title') + ' h4'}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {excerpt && (
          <p
            className={bem('c-post-card', 'excerpt')}
            dangerouslySetInnerHTML={{ __html: excerpt }}
          />
        )}
        <div className={bem('c-link-with-svg', '', { 'arrow-right': true })}>{__('more')}</div>
      </div>
    </a>
  );
};

PostCard.propTypes = {
  permalink: PropTypes.string,
  image: PropTypes.object,
  info: PropTypes.string,
  title: PropTypes.string,
  excerpt: PropTypes.string,
  style: PropTypes.object
};
